import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { signIn } = useAuth();
  const navigate   = useNavigate();
  const [id,      setId]      = useState('');
  const [pw,      setPw]      = useState('');
  const [showPw,  setShowPw]  = useState(false);
  const [err,     setErr]     = useState('');
  const [loading, setLoading] = useState(false);

  async function handle(e) {
    e.preventDefault(); setErr(''); setLoading(true);
    const { error } = await signIn(id.trim(), pw);
    if (error) { setErr('Invalid email/phone or password. Please try again.'); setLoading(false); return; }
    setTimeout(() => navigate('/'), 200);
    setLoading(false);
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      background: 'linear-gradient(160deg, #002277 0%, #003399 45%, #CC0000 100%)',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Background pattern */}
      <div style={{
        position: 'absolute', inset: 0, opacity: .04,
        backgroundImage: 'repeating-linear-gradient(45deg, white 0, white 1px, transparent 0, transparent 50%)',
        backgroundSize: '20px 20px',
        pointerEvents: 'none',
      }} />

      {/* Left panel — branding */}
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '40px 40px', color: 'white',
        display: 'none',
      }} className="login-left">
        <img src="/pcea-logo.png" alt="PCEA Logo" style={{ width: 160, marginBottom: 28, filter: 'drop-shadow(0 4px 16px rgba(0,0,0,.4))' }} />
        <div style={{ fontSize: 28, fontWeight: 900, textAlign: 'center', lineHeight: 1.2 }}>
          PCEA Thing'ati<br/>Church
        </div>
        <div style={{ fontSize: 14, opacity: .75, marginTop: 8, textAlign: 'center' }}>
          Ngecha, Limuru
        </div>
        <div style={{ marginTop: 40, fontSize: 13, opacity: .6, textAlign: 'center', lineHeight: 2 }}>
          Faith &nbsp;·&nbsp; Love &nbsp;·&nbsp; Hope
        </div>
      </div>

      {/* Right panel — login form */}
      <div style={{
        flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 20,
      }}>
        <div style={{
          background: 'white', borderRadius: 20, padding: '40px 36px',
          width: '100%', maxWidth: 420,
          boxShadow: '0 24px 64px rgba(0,0,0,.3)',
        }}>
          {/* Logo + Title */}
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <img
              src="/pcea-logo.png"
              alt="PCEA Thingati Logo"
              style={{ width: 90, height: 90, objectFit: 'contain', marginBottom: 16, filter: 'drop-shadow(0 2px 8px rgba(0,0,0,.15))' }}
            />
            <div style={{ fontWeight: 900, fontSize: 20, color: '#003399', lineHeight: 1.2 }}>
              PCEA Thing'ati Church
            </div>
            <div style={{ fontSize: 12, color: '#78909C', marginTop: 4 }}>
              Church Management System
            </div>
            <div style={{ fontSize: 11, color: '#90A4AE', marginTop: 2, fontStyle: 'italic' }}>
              Faith · Love · Hope
            </div>
          </div>

          {/* Divider */}
          <div style={{ height: 1, background: 'linear-gradient(to right, transparent, #E0E0E0, transparent)', marginBottom: 24 }} />

          <form onSubmit={handle}>
            {err && (
              <div className="alert alert-danger mb-3" style={{ fontSize: 13 }}>
                ⚠️ {err}
              </div>
            )}

            <div className="form-group">
              <label className="form-label">Email or Phone Number</label>
              <input
                className="form-input"
                value={id}
                onChange={e => setId(e.target.value)}
                placeholder="admin@pceathingati.org or +2547XXXXXXXX"
                required
                autoComplete="username"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  className="form-input"
                  type={showPw ? 'text' : 'password'}
                  value={pw}
                  onChange={e => setPw(e.target.value)}
                  placeholder="Your password"
                  style={{ paddingRight: 44 }}
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPw(p => !p)}
                  style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, color: '#90A4AE' }}
                >
                  {showPw ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-full"
              disabled={loading}
              style={{
                marginTop: 8, padding: '12px', fontSize: 15, fontWeight: 700,
                background: 'linear-gradient(135deg, #003399, #CC0000)',
                color: 'white', border: 'none', borderRadius: 10,
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? .7 : 1,
                transition: 'opacity .2s',
              }}
            >
              {loading ? ' Signing in…' : ' Sign In'}
            </button>
          </form>

          {/* Footer */}
          <div style={{ marginTop: 28, textAlign: 'center' }}>
            <div style={{ fontSize: 11, color: '#90A4AE' }}>
              Presbyterian Church of East Africa<br />
              Thing'ati Church · Ngecha Parish · Ngecha Presbytery
            </div>
            <div style={{ marginTop: 12, fontSize: 10, color: '#B0BEC5' }}>
              © {new Date().getFullYear()} PCEA Thing'ati. All rights reserved.
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (min-width: 768px) {
          .login-left { display: flex !important; }
        }
      `}</style>
    </div>
  );
}